import { esc, modalCloseBtn } from '../ui/modal';
import { t } from '../ui/lang';
/**
 * Comment popup for one row of the operations registry.
 *
 * Deliberately NOT openModal(): that primitive owns the single #modal-backdrop and
 * replaces its content, so opening a second modal would destroy the operations window
 * underneath (filters, page, scroll position and all). This renders a modal-looking
 * overlay INSIDE the operations modal instead — it stacks above it (z-index 410 vs the
 * backdrop's 400), and it dies with it, since a hidden backdrop hides its subtree.
 *
 * Read-only text, so unlike the app's form modals a click outside or Esc dismisses it —
 * there is no input to lose.
 */
export function showOperationCommentModal(host, comment, subtitle) {
    // Only ever one comment popup at a time (clicking a second row replaces the first).
    host.querySelector('.ops-comment-overlay')?.remove();
    const overlay = document.createElement('div');
    overlay.className = 'ops-comment-overlay';
    overlay.innerHTML = `
        <div class="ops-comment-card">
            ${modalCloseBtn()}
            <h2 class="modal__title">${t('clickertab.comment')}</h2>
            <p class="settings-hint ops-comment-meta">${esc(subtitle)}</p>
            <div class="ops-comment-text">${esc(comment)}</div>
        </div>
    `;
    const onKey = (e) => {
        // Capture phase + stopPropagation: Esc closes the comment only, never the
        // operations window behind it.
        if (e.key === 'Escape') {
            e.stopPropagation();
            close();
        }
    };
    const close = () => {
        document.removeEventListener('keydown', onKey, true);
        overlay.remove();
    };
    overlay.querySelector('.modal__close').addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay)
        close(); });
    document.addEventListener('keydown', onKey, true);
    host.appendChild(overlay);
}
